import PptxGenJS from "pptxgenjs";

export function roundToTwo(num: number): number {
    return Math.round(num * 100) / 100;
}

export const slide4 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide()
    const reportData = data?.data
    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });
    slide.addText("Key Insights", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 20,
        bold: true,
        color: '000000'
    });
    const addProgressBar = (s: any, x: number, y: number, w: number, score: number, globalNorm: number) => {
        const barHeight = 0.1;
        const scale = 5;
        const orangeWidth = (Math.min(score, scale) / scale) * w;
        const normPos = (Math.min(globalNorm, scale) / scale) * w;
        // Background bar
        s.addShape('rect', {
            x: x, y: y, w: w, h: barHeight,
            fill: { color: 'F0F0F0' },
            line: { type: 'none' }
        });
        s.addShape('rect', {
            x: x, y: y, w: orangeWidth, h: barHeight,
            fill: { color: 'FF6600' },
            line: { type: 'none' }
        });

        // Global Norm tick
        s.addShape('rect', {
            x: x + normPos, y: y - 0.05, w: 0.03, h: barHeight + 0.1,
            fill: { color: '404040' },
            line: { type: 'none' }
        });
    };

    // --- SECTION 1: KEY STRENGTH ---
    const rawStrengths = reportData?.participantReport?.combinedScores?.length ?
        reportData?.participantReport?.combinedScores
        : []
    const keyStrengthCompetency = rawStrengths
        ?.sort((a: any, b: any) => {
            const aScore = a?.my_score ?? null;
            const bScore = b?.my_score ?? null;
            if (aScore === null && bScore === null) return 0;
            if (aScore === null) return 1;
            if (bScore === null) return -1;
            return bScore - aScore;
        })[0]

    const section1Top = 1.4;
    slide.addText("Key Strength (Your competency area with the highest score)", {
        x: 0.5,
        y: section1Top,
        w: 7.27,
        h: 0.3,
        fontSize: 12,
        bold: true,
        color: '000000'
    });

    // Detail Box for Strength
    const strengthBoxTop = section1Top + 0.3;
    const strengthBoxH = 2.4;
    slide.addShape('rect', { x: 0.5, y: strengthBoxTop, w: 7.27, h: strengthBoxH, line: { color: '404040', width: 1 } });

    // Competency Title
    slide.addText(`${keyStrengthCompetency?.tag}`, { x: 0.7, y: strengthBoxTop + 0.1, w: 3, h: 0.4, fontSize: 16, bold: true });

    // Score Boxes
    slide.addShape('rect', { x: 2.0, y: strengthBoxTop + 0.5, w: 0.9, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("YOUR SCORE", { x: 2.0, y: strengthBoxTop + 0.55, w: 0.9, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${parseFloat(keyStrengthCompetency?.my_score).toFixed(2)}`, { x: 2.0, y: strengthBoxTop + 0.65, w: 0.9, h: 0.3, fontSize: 18, bold: true, color: 'FF6600', align: 'center' });

    slide.addShape('rect', { x: 3.1, y: strengthBoxTop + 0.5, w: 0.9, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("GLOBAL NORM", { x: 3.1, y: strengthBoxTop + 0.55, w: 0.9, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${parseFloat(keyStrengthCompetency?.global_norm).toFixed(2)}`, { x: 3.1, y: strengthBoxTop + 0.65, w: 0.9, h: 0.3, fontSize: 18, bold: true, align: 'center' });
    // Bar Chart
    const barW = 8.0;
    const barX = 4.5;
    const barY = strengthBoxTop + 0.55;
    const maxValue1 = 5;
    const scale1 = (0.35 * barW) / maxValue1;
    const myScoreW1 = Math.min(parseFloat(keyStrengthCompetency?.my_score) * scale1, (0.35 * barW));
    const globalNormW1 = Math.min(parseFloat(keyStrengthCompetency?.global_norm) * scale1, (0.35 * barW));
    slide.addShape('rect', { x: barX, y: barY, w: myScoreW1, h: 0.25, fill: { color: 'FF6600' } });
    slide.addShape('rect', { x: barX, y: barY + 0.25, w: globalNormW1, h: 0.25, fill: { color: '000000' } });
    for (let num = 0; num <= maxValue1; num++) {
        const posX = barX + (num / maxValue1) * (0.35 * barW) - 0.05;
        slide.addText(num.toString(), {
            x: posX,
            y: barY + 0.55,
            w: 0.1,
            h: 0.1,
            fontSize: 7,
            color: '808080'
        });
    }
    // Rater Table
    const table1Top = strengthBoxTop + 1.3;
    slide.addShape('rect', { x: 0.5, y: table1Top, w: 7.27, h: 0.25, fill: { color: 'F8F8F8' }, line: { color: '404040' } });
    const headers = ["Rater", "Your Score", "Global Norm", "Comparison"];
    const headerX = [0.6, 3.2, 3.8, 4.4];
    headers.forEach((h, i) => {
        slide.addText(h, { x: headerX[i], y: table1Top, w: 1, h: 0.25, fontSize: 7, bold: true });
    });

    type RoleAverage = {
        role: string;
        avg_overall_average: number;
    };

    function sumAverages(data: RoleAverage[]): number {
        if (data.length === 0) return 0;
        return data.reduce((sum, item) => sum + item.avg_overall_average, 0) / data?.length;
    }

    let raters1 = [
        {
            name: "Total", score:
                roundToTwo(sumAverages(keyStrengthCompetency?.raters))
            , norm: roundToTwo(keyStrengthCompetency?.global_norm)
        }
    ]
    raters1 = raters1.concat([
        { name: "Self", score: roundToTwo(keyStrengthCompetency?.my_score), norm: roundToTwo(keyStrengthCompetency?.global_norm) },
    ])
    raters1 = raters1.concat(keyStrengthCompetency?.raters.map((r: any) => {
        return {
            name: r?.role,
            score: roundToTwo(r?.avg_overall_average),
            norm: roundToTwo(keyStrengthCompetency?.global_norm)
        }
    }))

    raters1.forEach((r, i) => {
        const rowY = table1Top + 0.25 + (i * 0.2);
        slide.addShape('rect', { x: 0.5, y: rowY, w: 7.27, h: 0.2, line: { color: 'E0E0E0', width: 0.5 } });
        slide.addText(r.name, { x: 0.6, y: rowY, w: 2, h: 0.2, fontSize: 8 });
        slide.addText(r.score.toString(), { x: 3.2, y: rowY, w: 0.5, h: 0.2, fontSize: 9, bold: true, color: 'FF6600' });
        slide.addText(r.norm.toString(), { x: 3.8, y: rowY, w: 0.5, h: 0.2, fontSize: 9 });
        addProgressBar(slide, 4.4, rowY + 0.05, 3.2, r.score, r.norm);
    });

    // Description text for Strength
    const descS = "You demonstrate exceptional ability in driving organizational change and transformation. Your scores consistently exceed global norms across all rater groups, indicating that you are recognized as a change catalyst within your organization. Stakeholders particularly appreciate your ability to communicate a clear vision for change and mobilize teams effectively during periods of transition.";
    slide.addText(descS, {
        x: 0.5,
        y: strengthBoxTop + strengthBoxH + 0.1,
        w: 7.27,
        h: 1.0,
        fontSize: 10,
        color: '404040'
    });

    // --- SECTION 2: GROWTH AREA ---
    const section2Top = 5.4;
    slide.addText("Growth Area (Your competency area with the lowest score.)", {
        x: 0.5,
        y: section2Top,
        w: 7.27,
        h: 0.3,
        fontSize: 12,
        bold: true,
        color: '000000'
    });

    const keyGrowthCompetency = rawStrengths
        ?.sort((a: any, b: any) => {
            const aScore = a?.my_score ?? null;
            const bScore = b?.my_score ?? null;
            if (aScore === null && bScore === null) return 0;
            if (aScore === null) return 1;
            if (bScore === null) return -1;
            return aScore - bScore;
        })[0]

    const growthBoxTop = section2Top + 0.3;
    slide.addShape('rect', { x: 0.5, y: growthBoxTop, w: 7.27, h: strengthBoxH, line: { color: '404040', width: 1 } });

    slide.addText(`${keyGrowthCompetency?.tag}`, { x: 0.7, y: growthBoxTop + 0.1, w: 4, h: 0.4, fontSize: 16, bold: true });

    slide.addShape('rect', { x: 2.0, y: growthBoxTop + 0.5, w: 0.9, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("YOUR SCORE", { x: 2.0, y: growthBoxTop + 0.55, w: 0.9, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${roundToTwo(keyGrowthCompetency?.my_score)}`, { x: 2.0, y: growthBoxTop + 0.65, w: 0.9, h: 0.3, fontSize: 18, bold: true, color: 'FF6600', align: 'center' });

    slide.addShape('rect', { x: 3.1, y: growthBoxTop + 0.5, w: 0.9, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("GLOBAL NORM", { x: 3.1, y: growthBoxTop + 0.55, w: 0.9, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${roundToTwo(keyGrowthCompetency?.global_norm)}`, { x: 3.1, y: growthBoxTop + 0.65, w: 0.9, h: 0.3, fontSize: 18, bold: true, align: 'center' });

    const barY2 = growthBoxTop + 0.55;
    const containerW = 8;
    const maxValue = 5;
    const scale = (0.35 * containerW) / maxValue;
    const myScoreW = Math.min(parseFloat(keyGrowthCompetency?.my_score) * scale, (0.35 * containerW));
    const globalNormW = Math.min(parseFloat(keyGrowthCompetency?.global_norm) * scale, (0.35 * containerW));
    slide.addShape('rect', { x: barX, y: barY2, w: myScoreW, h: 0.25, fill: { color: 'FF6600' } });
    slide.addShape('rect', { x: barX, y: barY2 + 0.25, w: globalNormW, h: 0.25, fill: { color: '000000' } });
    for (let num = 0; num <= maxValue; num++) {
        const posX = barX + (num / maxValue) * (0.35 * containerW) - 0.05;
        slide.addText(num.toString(), {
            x: posX,
            y: barY2 + 0.55,
            w: 0.1,
            h: 0.1,
            fontSize: 7,
            color: '808080'
        });
    }

    const table2Top = growthBoxTop + 1.3;
    slide.addShape('rect', { x: 0.5, y: table2Top, w: 7.27, h: 0.25, fill: { color: 'F8F8F8' }, line: { color: '404040' } });
    headers.forEach((h, i) => {
        slide.addText(h, { x: headerX[i], y: table2Top, w: 1, h: 0.25, fontSize: 7, bold: true });
    });

    let raters2 = [
        { name: "Total", score: roundToTwo(sumAverages(keyGrowthCompetency?.raters)), norm: keyGrowthCompetency?.global_norm },
    ];
    raters2 = raters2.concat([
        { name: "Self", score: roundToTwo(keyGrowthCompetency?.my_score), norm: roundToTwo(keyGrowthCompetency?.global_norm) },
    ])
    raters2 = raters2.concat(keyGrowthCompetency?.raters.map((r: any) => {
        return {
            name: r?.role,
            score: roundToTwo(r?.avg_overall_average),
            norm: roundToTwo(keyGrowthCompetency?.global_norm)
        }
    }))

    raters2.forEach((r, i) => {
        const rowY = table2Top + 0.25 + (i * 0.2);
        slide.addShape('rect', { x: 0.5, y: rowY, w: 7.27, h: 0.2, line: { color: 'E0E0E0', width: 0.5 } });
        slide.addText(r.name, { x: 0.6, y: rowY, w: 2, h: 0.2, fontSize: 8 });
        slide.addText(r.score.toFixed(1), { x: 3.2, y: rowY, w: 0.5, h: 0.2, fontSize: 9, bold: true, color: 'FF6600' });
        slide.addText(r.norm.toFixed(1), { x: 3.8, y: rowY, w: 0.5, h: 0.2, fontSize: 9 });
        addProgressBar(slide, 4.4, rowY + 0.05, 3.2, r.score, r.norm);
    });

    const descG = "Your scores in this competency fall below global norms, suggesting an opportunity to strengthen your external network and partnership-building capabilities. Feedback indicates that while you maintain strong internal relationships, there may be opportunities to expand your influence across organizational boundaries and cultivate more strategic external partnerships.";
    slide.addText(descG, {
        x: 0.5,
        y: growthBoxTop + strengthBoxH + 0.1,
        w: 7.27,
        h: 0.7,
        fontSize: 10,
        color: '404040'
    });

    slide.addText("To Build This Competency:", {
        x: 0.5,
        y: growthBoxTop + strengthBoxH + 0.8,
        w: 7.27,
        h: 0.2,
        fontSize: 11,
        bold: true,
        color: '000000'
    });

    const buildSteps = "Focus on scheduling regular networking activities outside your immediate team. Identify key stakeholders across different business units and establish regular touchpoints. Consider seeking a mentor who excels in relationship building, and actively participate in cross-functional initiatives. Set a goal to initiate at least two strategic conversations per week with leaders outside your direct reporting line.";
    slide.addText(buildSteps, {
        x: 0.5,
        y: growthBoxTop + strengthBoxH + 1.1,
        w: 7.27,
        h: 0.8,
        fontSize: 10,
        color: '404040'
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("5", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};
